import { render, staticRenderFns } from "./markdownPreview.vue?vue&type=template&id=828d453a&scoped=true"
import script from "./markdownPreview.vue?vue&type=script&lang=js"
export * from "./markdownPreview.vue?vue&type=script&lang=js"
import style0 from "./markdownPreview.vue?vue&type=style&index=0&id=828d453a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828d453a",
  null
  
)

export default component.exports